
import BlogSections from "../components/BlogSections";
import CTA from "../components/CTA";
import FeatureSection from "../components/FeatureSection";
import Hero from "../components/Hero";
import LogoCloud from "../components/LogoCloud";
import SocialCTA from "../components/SocialCTA";

const Home = () => {
  return (
    <>
      <Hero />
      <FeatureSection />
      <CTA />
      <LogoCloud />
      <SocialCTA />
      {/* <BlogSections /> */}
    </>
  );
}

export default Home;
